import { Component, Input } from '@angular/core';



export interface IBenefits {
  returnWarranityDays?: number,
  yearlyWarranity?: number,
  nonReturnable?: boolean, 
  shippingWeeksMin?: number,
  shippingWeeksMax?: number
}
@Component({
  selector: 'app-item-benefits',
  standalone: true,
  imports: [],
  templateUrl: './item-benefits.component.html',
  styleUrl: './item-benefits.component.scss'
})
export class ItemBenefitsComponent {
  @Input() benefits!: any;
  @Input() singleBenefitStyles: boolean = false;
  @Input() darkMode: boolean = false;

  @Input() classess!: string;
}
